












































































































































































































































































































































































import { Component, Vue, Inject, Prop, Watch } from 'vue-property-decorator'
import PicModal from '@/components/upload/picModal.vue'
import SelectUrl from './selectUrl.vue'
@Component({
  components: {
    PicModal,
    SelectUrl,
  },
})
export default class HomeSetPic extends Vue {
  @Prop({
    type: Object,
    default: () => {
      return {
        type: 'pictures',
        styleType: 0,
        imgUrl: [
          {
            img: null,
            url: null,
          },
        ],
      }
    },
  })
  PicturesConfig!: any

  //选择的图片下标
  selectIndex = 0

  styleList = [
    {
      img: require('@/assets/images/shopMall/pc/pic/1.jpg'),
      title: '一行一个',
      num: 1,
      type: 0,
    },
    {
      img: require('@/assets/images/shopMall/pc/pic/2.jpg'),
      title: '一行两个',
      num: 2,
      type: 1,
    },
    {
      img: require('@/assets/images/shopMall/pc/pic/3.jpg'),
      title: '一行三个',
      num: 3,
      type: 2,
    },
    {
      img: require('@/assets/images/shopMall/pc/pic/4.jpg'),
      title: '一行四个',
      num: 4,
      type: 3,
    },
    {
      img: require('@/assets/images/shopMall/pc/pic/6.jpg'),
      title: '一行五个',
      num: 5,
      type: 5,
    },
    {
      img: require('@/assets/images/shopMall/pc/pic/5.jpg'),
      title: '两左两右',
      num: 4,
      type: 4,
    },
    {
      img: require('@/assets/images/shopMall/pc/pic/7.jpg'),
      title: '一左四右',
      num: 5,
      type: 6,
    },
    {
      img: require('@/assets/images/shopMall/pc/pic/8.jpg'),
      title: '左二右一',
      num: 3,
      type: 7,
    },
    {
      img: require('@/assets/images/shopMall/pc/pic/9.jpg'),
      title: '左一右二',
      num: 3,
      type: 8,
    },
    {
      img: require('@/assets/images/shopMall/pc/pic/10.jpg'),
      title: '左四右一',
      num: 5,
      type: 9,
    },
  ]

  get imgObj() {
    return this.PicturesConfig.imgUrl[this.selectIndex]
  }

  mounted() {}

  /**
   * 样式更改
   */
  styleChange(row, type) {
    console.log(row, type)
    this.PicturesConfig.styleType = type
    if (this.PicturesConfig.imgUrl.length < row.num) {
      let len = row.num - this.PicturesConfig.imgUrl.length
      for (let i = 0; i < len; i++) {
        let obj = {
          img: null,
          url: null,
        }
        this.PicturesConfig.imgUrl.push(obj)
      }
    } else if (this.PicturesConfig.imgUrl.length > row.num) {
      let len = this.PicturesConfig.imgUrl.length - row.num
      this.PicturesConfig.imgUrl.splice(row.num, len)
    }
    this.selectIndex = 0
  }

  /**
   * 选择图片
   */
  picChange(e) {
    console.log('pic')
    this.PicturesConfig.imgUrl[this.selectIndex]['img'] = e[0].url
  }

  urlChange(e) {
    this.imgObj.url = e
  }

  /**
   * 选择虚线框
   */
  selectChange(index) {
    this.selectIndex = index
  }

  /**
   * 删除图片
   */
  deleteFn(index) {
    this.PicturesConfig.imgUrl.splice(index, 1)
  }

  /**
   * 添加图片
   */
  addFn() {
    let obj = {
      img: null,
      url: null,
    }
    this.PicturesConfig.imgUrl.push(obj)
  }
}
